export default __webpack_public_path__ + "static/media/2_0136.e0dbb568.webp";